import React, { useState, useEffect } from "react";
import { Grid, Typography, ToggleButton, Button, Box } from "@mui/material";
import DOMPurify from "dompurify";
import moment from "moment";
import { GetReportHtml, zipApi } from "../../../../../../api";
import DownloadIcon from "@mui/icons-material/Download";

const ReportingData = (props) => {
  const { study, section, hideFreeze, studyId, hideConsult, sx } = props;
  const [html, setHtml] = useState()
  const [reportObj, setReportObj] = useState()
  const [expanded, setExpanded] = useState(false)
  const [freeze, setFreeze] = useState(false)

  useEffect(() => {
    if (hideConsult) return
    GetReportHtml(study.id).then(obj => {
      setReportObj(obj)
      setHtml(obj.consult)
    }).catch(e => e)
  }, [study, section, hideConsult])

  if (!study) return <React.Fragment />;

  return (
    <>
      <Grid container spacing={3} sx={{ ...sx, position: (freeze && 'sticky') || 'static', top: 0, zIndex: 10, borderBottom: (freeze && '1px solid rgba(255, 255, 255, 0.7)') || 'none', backgroundColor: (freeze && '#121212') || 'inherit'}}>
        <Grid size={5}>
          <Typography variant="h6">Patient:</Typography>
          <Typography variant="body1">
            ID: {study.PatientMainDicomTags.PatientID}
          </Typography>
          <Typography variant="body1">
            Name: {study.PatientMainDicomTags.PatientName}
          </Typography>
          <Typography variant="body1">
            Owner: {study.PatientMainDicomTags.ResponsiblePerson}
          </Typography>
          <Typography variant="body1">
            Species: {study.PatientMainDicomTags.PatientSpeciesDescription}
          </Typography>
          <Typography variant="body1">
            Breed: {study.PatientMainDicomTags.PatientBreedDescription}
          </Typography>
          <Typography variant="body1">
            DOB:{" "}
            {moment(study.PatientMainDicomTags.PatientBirthDate).format(
              "MM-DD-YYYY"
            )}
          </Typography>
          <Typography variant="body1">
            Age:{" "}
            {moment.duration(moment().diff(study.PatientMainDicomTags.PatientBirthDate)).humanize()}
          </Typography>
          <Typography variant="body1">
            Sex: {study.PatientMainDicomTags.PatientSex}
          </Typography>
          <Typography variant="body1">
            Weight: {study.PatientMainDicomTags.PatientWeight ? study.PatientMainDicomTags.PatientWeight + "kg" : ""}
          </Typography>
        </Grid>
        <Grid size={2} />
        <Grid size={5}>
          {study.MainDicomTags.ReferringPhysicianName && (
            <>
              <Typography variant="h6">Referring Physician:</Typography>
              <Typography sx={{ mb: 2 }} variant="body1">{study.MainDicomTags.ReferringPhysicianName}</Typography>
            </>
          )}
          <Typography variant="h6">Requested by:</Typography>
          {(study.associateOrg && (
            <>
              <Typography variant="body1">{study.associateOrg.name}</Typography>
              <Typography variant="body1">{study.associateOrg.address}</Typography>
              <Typography variant="body1">
                {study.associateOrg.city}, {study.associateOrg.state}&nbsp;
                {study.associateOrg.zip}
              </Typography>
              <Typography variant="body1">{study.associateOrg.phone}</Typography>
              <Typography variant="body1">{Array.isArray(study.associateOrg.email) ? study.associateOrg.email[0] : study.associateOrg.email}</Typography>
            </>
          )) || (study.consultBy?.org && (
              <>
                <Typography variant="body1">{study.consultBy.org.name}</Typography>
                <Typography variant="body1">{study.consultBy.org.address}</Typography>
                <Typography variant="body1">
                  {study.consultBy.org.city}, {study.consultBy.org.state}&nbsp;
                  {study.consultBy.org.zip}
                </Typography>
                <Typography variant="body1">{study.consultBy.org.phone}</Typography>
                <Typography variant="body1">{Array.isArray(study.consultBy.org.email) ? study.consultBy.org.email[0] : study.consultBy.org.email}</Typography>
              </>
            ))}

          {!hideFreeze && (
            <Grid size={12}>
              <Grid container justifyContent="flex-end" spacing={1} alignItems="center">
                {studyId && <Button sx={{lineHeight:1}} variant="outlined" component="a" href={`${zipApi}studies/${studyId}/zip`} target="_blank" startIcon={<DownloadIcon />}>Download</Button>}
                <ToggleButton sx={{lineHeight:1}} value="freeze" color="primary" selected={freeze} onChange={() => setFreeze(prev => !prev)}>Freeze</ToggleButton>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      {!hideConsult && (
        <Grid container spacing={3}>
          <Grid sx={{ mt: 1 }}>
            <Typography>Number of images: {study.instanceCount + (study.numImages || study.numImages === 0 ? ` of ${study.numImages}` : '')}</Typography>
          </Grid>
          <Grid size={12} sx={{"& *": { margin: 0, color: '#fff !important' }, "& img": {maxHeight: '17em', maxWidth: '100%'}, "& h1.__root_label": {fontSize: '11pt', margin: '1em 0'} }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}></Grid>
          {(section === 'consult' ? study.prelimReport : true) && !expanded && (
            <Grid size={12}>
              <Box>
                <Button variant="outlined" onClick={() => { setHtml(html + (section === 'consult' ? (reportObj?.prelimReport || '') : (reportObj?.report || reportObj?.prelimReport || ''))); setExpanded(true); }}>{section === 'consult' ? 'Expand Prelim Report' : 'Expand Consult Report'}</Button>
              </Box>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};
export default ReportingData;
